<template>
  <div></div>
</template>

<script>
export default {
  name: 'AuthCallback',
  async mounted() {
    this.$store.dispatch('loading/setIsLoadingCircular', true);
    this.$store
      .dispatch('auth/redirectCallback')
      .then((userInfo) => {
        if (userInfo.isSuperUser) {
          this.$router.push({ name: 'Login', params: { errorMessage: 'ログイン権限がありません' } });
          return;
        }
        // 認証成功
        this.$router.push({ name: 'CabinetMaster' });
      })
      .catch(async (error) => {
        this.$store.dispatch('message/clearMessages');
        try {
          await this.$store.dispatch('auth/logout');
        } catch (e) {
          console.error('logout error', e);
        }
        const status = error && error.response && error.response.status;
        const errorMessage = status === 400 ? 'ユーザーの認証に失敗しました。' : 'ログインでエラーが発生しました';
        this.$router.push({ name: 'Login', params: { errorMessage } });
      })
      .finally(() => {
        this.$store.dispatch('loading/setIsLoadingCircular', false);
      });
  }
};
</script>
